import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 border-t border-amber-500/30 py-10 px-4 text-center" data-id="element-105" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white/60" data-id="element-106" data-mp="3ggty8ibanj58">© Olympic Weightlifting Coach Ready 2026 — All rights reserved.</p>
    </footer>;
}